(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.New.FieldListView",
                {
                    url: "/FieldList",
                    component: "fieldListView"
                });
        }
    ]);

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.Edit.FieldListView",
                {
                    url: "/FieldList",
                    component: "fieldListView"
                });
        }
    ]);

    app.component("fieldListView",
        {
            templateUrl: "/App/Reports/EditReport/FieldListView/field-list-view.template.html",
            controller: fieldListViewController,
            bindings: {
                activeCustomFields: "=",
                activeFields: "=",
                condition: "=",
                customConditions: "=",
                customFields: "=",
                fields: "=",
                searchText: "=",
                unsaved: "=",
                reportType: "="
            }
        });

    fieldListViewController.$inject = ["_"];
    function fieldListViewController(_) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {}
            });

        $ctrl.fieldFilter = field => {
            if (!$ctrl.searchText) return true;
            $ctrl.searchText = !!$ctrl.searchText ? $ctrl.searchText.toLowerCase() : '';
            if (field.DisplayName.toLowerCase().indexOf($ctrl.searchText) !== -1) return true; //|| field.Active 
            return false;
        };

        $ctrl.toggleField = field => {
            if (!field.Active) {
                _.remove($ctrl.activeFields,
                    function (row) {
                        return row.Name === field.Name;
                    });

                _.remove($ctrl.condition.parameters,
                    function (row) {
                        return row.parameters[0].parameter === field.Name || row.parameters[0].parameter === field.ConditionName ||
                            row.parameters[0].parameters && row.parameters[0].parameters[1].parameter === field.Name;
                    });
            } else {
                $ctrl.activeFields.push(field);
            }

            $ctrl.ui.selectAll = $ctrl.fields.length === $ctrl.activeFields.length;
            $ctrl.unsaved = true;
        };

        $ctrl.toggleCustomField = customField => {
            if (!customField.Active) {
                _.remove($ctrl.activeCustomFields,
                    function (row) {
                        return row.Id === customField.Id;
                    });

                _.remove($ctrl.customConditions,
                    function (row) {
                        return row.Parameter === customField.Id;
                    });
            } else {
                $ctrl.activeCustomFields.push(customField);
            }

            $ctrl.ui.selectAllCustomFields = $ctrl.customFields.length === $ctrl.activeCustomFields.length;
            $ctrl.unsaved = true;
        };

        $ctrl.selectAll = () => {
            $ctrl.activeFields = [];
            ng.forEach($ctrl.fields,
                (field) => {
                    field.Active = $ctrl.ui.selectAll;

                    if ($ctrl.ui.selectAll) {
                        $ctrl.activeFields.push(field);
                    }
                });

            $ctrl.unsaved = true;
        };

        $ctrl.selectAllCustomFields = () => {
            $ctrl.activeCustomFields = [];
            ng.forEach($ctrl.customFields,
                function (customField) {
                    customField.Active = $ctrl.ui.selectAllCustomFields;

                    if ($ctrl.ui.selectAllCustomFields) {
                        $ctrl.activeCustomFields.push(customField);
                    } else {
                        $ctrl.customConditions = [];
                    }
                });

            $ctrl.unsaved = true;
        };

        $ctrl.$onInit = () => {
            $ctrl.ui.selectAll = $ctrl.fields.length === $ctrl.activeFields.length;
            $ctrl.ui.selectAllCustomFields = !!$ctrl.activeCustomFields.length && $ctrl.activeCustomFields.length === $ctrl.customFields.length;
        };
    }

})(window.app, window.angular);